export const sendMessage = (queuedMessage) => {
    console.log(queuedMessage)
};